import axios from "axios";
import {
  GET_ALL_LEDGER_BALANCE,
} from "../../../config/config";
import { IAPIPayload } from "../../../interfaces/apiInterface";

export const getAllLedgerBalanceList = (data: IAPIPayload) => {
  return axios.post(GET_ALL_LEDGER_BALANCE, data);
};
